import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Adal8Service } from 'adal-angular8';
import { BaseService } from './base.service';
import { CommonService } from './common.service';
import { ConstantsService } from './constants.service';
import { DataService } from './data.service';

@Injectable()
export class AuthenticationService {
  private redirectUri;
  constructor(
    private service: Adal8Service,
    private baseService: BaseService,
    private dataService: DataService,
    private commonService: CommonService,
    private http: HttpClient,
  ) {}

  fetchIPInfo() {
    const savedIP = this.baseService.getItemFromSession('ipAddress');
    if (!savedIP || savedIP === 'null' || savedIP === '') {
      this.baseService.setItemInSession(
        'ipAddress',
        document.getElementById('ipaddress').innerHTML,
      );
    }
  }

  initAdal8ServiceConfig() {
    const config = {
      instance: ConstantsService.ADALCONFIGDETAILS.Instance,
      clientId: ConstantsService.ADALCONFIGDETAILS.ClientId,
      endpoints: {},
      anonymousEndpoints: ConstantsService.ADALCONFIG.ANONYMOUS_ENDPOINTS,
      cacheLocation: 'localStorage',
      redirectUri: ConstantsService.URL.APP,
      tenant: ConstantsService.ADALCONFIGDETAILS.Tenant,
      postLogoutRedirectUri: ConstantsService.URL.APP,
    };

    config.endpoints[ConstantsService.URL.API] =
      ConstantsService.ADALCONFIGDETAILS.ClientId;
    this.baseService.setItemInSession('adal-config', JSON.stringify(config));
    this.service.init(config);
  }

  fetchRequiredUserDetails() {
    // console.log(this.service.userInfo);
    // console.log(this.service.userInfo.profile);
    // console.log(this.service.userInfo.profile.upn);

    const request = {
      Model: {
        UserName: this.service.userInfo.profile.upn,
        Password: null,
      },
    };
    // Authenticate employee
    this.dataService
      .post(
        ConstantsService.APIURL.Authentication.AuthenticateEmployee,
        request,
      )
      .subscribe((response) => {
        if (
          response &&
          response.Success &&
          response.Result &&
          !response.Errors
        ) {
          this.baseService.setItemInSession(
            ConstantsService.EmployeeLoginResponse,
            JSON.stringify(response.Result),
          );
          this.baseService.setItemInSession(
            ConstantsService.ValidateEmployeeLoginResponse,
            'success',
          );
          this.getUserDetails();
        } else {
          this.getUserDetails();
          this.baseService.setItemInSession(
            ConstantsService.ValidateEmployeeLoginResponse,
            'failed',
          );
          this.baseService.processApiResponseError(response);
        }
      });
  }
  getUserDetails() {
    const apiRequest = {
      Model: {
        Email: this.service.userInfo.profile.upn,
        UserId: 0,
      },
    };
    this.commonService.getUserIndependentPermissionsByUserEmail(
      this.service.userInfo.profile.upn,
    );
    this.commonService.getUser(apiRequest, this.employeeSuccess.bind(this));
  }
  employeeSuccess(response) {
    if (response) {
      this.baseService.setItemInSession(
        'loggedInUser',
        JSON.stringify(response),
      );
      this.commonService.getUserIndependentPermissions(response.UserId);
      this.redirectUri =
        ConstantsService.URL.APP + ConstantsService.URL.HOMEPAGE;
      //window.open(this.redirectUri, '_self');
      this.baseService.navigateToLogOutUrl(ConstantsService.URL.APP);
      this.baseService.showRootLoader = false;
    } else {
      this.baseService.processApiResponseError(response);
    }
  }
  logout() {
    const loggedInUserType = this.baseService.getItemFromSession(
      ConstantsService.LoggedInUserType,
    );
    const adalConfig = this.baseService.getItemFromSession('adal-config');
    if (loggedInUserType === 'Employee') {
      const instanceurl =
        JSON.parse(adalConfig).instance +
        JSON.parse(adalConfig).tenant +
        '//oauth2/v2.0/logout?post_logout_redirect_uri=' +
        ConstantsService.URL.APP;
      this.baseService.navigateToLogOutUrl(instanceurl);
    }
    this.baseService.clearSession();
    this.service.logOut();
  }
}
